import { render } from "./ManageContentCategory.vue?vue&type=template&id=5f611e44"
import script from "./ManageContentCategory.vue?vue&type=script&lang=js"
export * from "./ManageContentCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__